// Time off — pure helpers (no DOM): day checkbox list, outbox payloads, range text.
import { addDays } from './timesheet-activity.js';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const dow = (iso) => new Date(Date.UTC(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10))).getUTCDay();

export function dayList(from, to) {
  if (!from || !to || to < from) return [];
  const out = [];
  for (let d = from; d && d <= to; d = addDays(d, 1)) {
    const w = dow(d);
    out.push({ date: d, checked: w !== 0 && w !== 6 });
  }
  return out;
}

export function requestPayload({ id, worker_id, kind, days, note }) {
  if (kind !== 'sick' && kind !== 'vacation') throw new Error('bad_kind');
  const list = [...new Set(days || [])].sort();
  if (!list.length) throw new Error('no_days');
  return { id, worker_id, kind, days: list, note: String(note || '').trim() || null, status: 'pending' };
}

export function decisionRecord(requestId, status, note) {
  if (status !== 'approved' && status !== 'denied') throw new Error('bad_status');
  return { requestId, decision: { status, decision_note: String(note || '').trim() || null } };
}

export function fmtDays(days) {
  const l = [...days].sort();
  const a = l[0], b = l[l.length - 1];
  const md = (s) => `${MONTHS[+s.slice(5, 7) - 1]} ${+s.slice(8, 10)}`;
  if (a === b) return md(a);
  return a.slice(0, 7) === b.slice(0, 7) ? `${md(a)}–${+b.slice(8, 10)}` : `${md(a)} – ${md(b)}`;
}

export const kindLabel = (k) => (k === 'sick' ? 'Sick' : 'Vacation');
export const statusLabel = (s) => ({ pending: 'Pending', approved: 'Approved', denied: 'Denied' }[s] || s);
export const sendLabel = (n) => `Send request · ${n} day${n === 1 ? '' : 's'}`;
